var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"periodo-referencia","rota-base":"/admin/periodo-referencia","titulo":"PERÍODOS (REFERÊNCIA)","titulo-singular":"Período","colunas-extras":[
        { campo: "hora_inicio", label: "Hora Início", tipo: "string" },
        { campo: "hora_fim", label: "Hora Fim", tipo: "string" }
    ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }